var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_279_4773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.89583 47.3875H42.1042C44.8047 47.3875 47 45.1741 47 42.4513V4.93619C47 2.21339 44.8047 0 42.1042 0H4.89583C2.19529 0 0 2.21339 0 4.93619V42.4513C0 45.1741 2.19529 47.3875 4.89583 47.3875ZM42.1042 1.97448C43.7237 1.97448 45.0417 3.3033 45.0417 4.93619V42.4513C45.0417 44.0842 43.7237 45.413 42.1042 45.413H4.89583C3.27629 45.413 1.95833 44.0842 1.95833 42.4513V4.93619C1.95833 3.3033 3.27629 1.97448 4.89583 1.97448H42.1042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3541 37.5151C30.6166 37.5151 30.879 37.4085 31.0709 37.1992C31.4391 36.8004 31.4175 36.1745 31.02 35.8052L18.0832 23.6938L31.02 11.5823C31.4175 11.2131 31.441 10.5872 31.0709 10.1884C30.7008 9.78556 30.08 9.76582 29.6883 10.137L15.98 22.9711C15.7802 23.1587 15.6666 23.4193 15.6666 23.6938C15.6666 23.9682 15.7802 24.2289 15.98 24.4164L29.6883 37.2505C29.8763 37.4282 30.1152 37.5151 30.3541 37.5151Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_279_4773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47.3875,
    fill: "white",
    transform: "matrix(-1 0 0 1 47 0)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.477a43e781651b8a2918fb7ced871864.svg";
export { ForwardRef as ReactComponent };